import { render } from "./Store.vue?vue&type=template&id=3ae6bc9a"
import script from "./Store.vue?vue&type=script&lang=ts"
export * from "./Store.vue?vue&type=script&lang=ts"
script.render = render

export default script